

module.exports = __webpack_require__.stylable.create(
    "Recurrence3479380146",
    {"classes":{"root":"Recurrence3479380146__root","frequency":"Recurrence3479380146__frequency"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Recurrence3479380146",
    null
);
